import { useQuery } from '@tanstack/react-query'

import type { EmployeeCheckinStatus } from '@/libs/interfaces'
import { checkInApi } from '@/services/api'

export function useTeamMembersStatus(storeID: string) {
  return useQuery<EmployeeCheckinStatus[]>({
    queryKey: ['check-in', 'temMemberStatus', storeID],
    enabled: !!storeID,
    queryFn: async () => {
      return await checkInApi.getcheckInStatus(storeID).then((data) => data.checkinStatuses)
    },
    refetchOnWindowFocus: false,
    staleTime: 10 * 60 * 1000, // 10 mins
  })
}
